import type { NodeSpec } from '@atlaskit/editor-prosemirror/model';
import { TextSelection } from '@atlaskit/editor-prosemirror/state';
import { expValEquals } from '@atlaskit/tmp-editor-statsig/exp-val-equals';

import type {
	StreamingCommandFactory,
	SetAttrsCommand,
} from '../aiStreamingOrchestratorPluginType';

import { findNodeByLocalId } from './utils/find-node-by-local-id';

const getValidAttributes = (attrs: Record<string, unknown>, nodeSpec: NodeSpec) => {
	const validAttrs: Record<string, unknown> = {};
	for (const key in attrs) {
		if (nodeSpec.attrs?.hasOwnProperty(key)) {
			validAttrs[key] = attrs[key];
		}
	}
	return validAttrs;
};

export const createSetAttrsCommand: StreamingCommandFactory<SetAttrsCommand> =
	(api) => (command) => {
		return api.core.actions.execute(({ tr }) => {
			let shouldExecute = false;
			findNodeByLocalId(api, tr, command.localId, ({ node, pos }) => {
				if (node) {
					const attrs = command.attrs;
					if (!attrs || typeof attrs !== 'object') {
						return;
					}
					const validAttrs = getValidAttributes(attrs, node.type.spec);
					node.type.spec.attrs;
					tr.setNodeMarkup(pos, node.type, {
						...node.attrs,
						...validAttrs,
					});
					if (expValEquals('platform_editor_ai_update_set_attrs_selection', 'isEnabled', true)) {
						tr.setSelection(TextSelection.near(tr.doc.resolve(pos)));
					}
					shouldExecute = true;
				}
			});
			return shouldExecute ? tr : null;
		});
	};
